import { LitEntity, SirenActionMixin, html } from './lit-entity';

class CustomDateRangeEntity extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.actionname = 'custom-date-range';
  }

  static get properties() {
    return {
      start: { type: String },
      end: { type: String },
      actionname: { type: String },
    };
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has('start') || changedProperties.has('end')) {
      this._updateDateRange();
    }
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this._updateDateRange();
  }

  async _updateDateRange() {
    if (!this.entity || !this.entity.hasAction(this.actionname)) {
      return;
    }
    const action = this.entity.getAction(this.actionname);
    const fields = this.getActionFields(action);
    const noDates = !this.start && !this.end;
    if (noDates) {
      this.dispatchEvent(new CustomEvent('rangeupdate', { detail: { entity: this.entity } }));
      return;
    }
    this.start && fields.set('startDate', this.start);
    this.end && fields.set('endDate', this.end);
    const { entity } = await this.submitAction(action, fields);
    this.dispatchEvent(new CustomEvent('rangeupdate', { detail: { entity } }));
  }

  render() {
    return html``;
  }
}

window.customElements.define('custom-date-range-entity', CustomDateRangeEntity);
